import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import "./assets/tailwind.css";

import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { AuthService } from "./services/auth/AuthService";

import AdminTopbar from "./components/organisms/AdminTopbar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/**
 * Importando recursos de tailwind. Si se borra esto, tailwind queda aislado
 * de la aplicación.
 */
const router = useRouter();
const route = useRoute();

const showTopbar = computed(() => {
  return typeof route.name == "string" && !route.name.includes("auth");
});

const authService = new AuthService();
async function checkSession() {
  if (route.name == "auth-forgot-password") {
    router.push({ name: "auth-forgot-password" });
    return;
  }
  if (route.name == "auth-forgot-password-return") {
    router.push({ name: "auth-forgot-password-return" });
    return;
  }
  /*const hasValidSession = await authService.hasValidUserSession();
      if (!hasValidSession) {
        router.push({ name: "auth-login" });
      }*/
}

onMounted(() => {
  checkSession();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showTopbar.value)
      ? (_openBlock(), _createBlock(AdminTopbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, {
      class: _normalizeClass({
      'mt-28 mb-10 mx-10': showTopbar.value,
    })
    }, null, 8, ["class"])
  ], 64))
}
}

})